import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { UAT_REVIEWER_FALLBACK, UAT_REVIEWER_PATHS } from '@/pages/platform/reviewerAccess';

const RequirePlatformAdmin = () => {
  const { user, isPlatformAdmin, isUatReviewer, loading, rolesLoading } = useAuth();
  const location = useLocation();
  const onReviewerPath = UAT_REVIEWER_PATHS.includes(location.pathname);

  if (loading || rolesLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  // Neither a platform admin nor a UAT reviewer: no platform access at all.
  if (!isPlatformAdmin && !isUatReviewer) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // UAT reviewer (without platform-admin): only the checklist routes are
  // allowed; any other platform route bounces to their checklist area.
  if (!isPlatformAdmin && isUatReviewer && !onReviewerPath) {
    return <Navigate to={UAT_REVIEWER_FALLBACK} replace />;
  }

  return <Outlet />;
};

export default RequirePlatformAdmin;
